import React, { useState, useEffect, useCallback } from "react";
import {
    Paper,
    Typography,
    Box,
    Alert,
    Snackbar,
    CircularProgress,
    Chip,
    Grid,
    } from "../ui";
import { Clock } from "lucide-react";
import CustomerSelector from "./components/CustomerSelector";
import { useSelector } from "react-redux";
import {
  getAuthSession,
  GET_CUSTOMER_DATA,
  getPreUrlAccordingToCart,
  SUCCESS
} from "../../constants/constant";
import { snpAxios } from "../global/api";

const MarketingPage = () => {
  // State
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);

  // UI State
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const storeCartType = useSelector(
    (state) => state.setCartTypeReducer.cartType,
  );
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash,
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL,
  );

  const fetchCustomerData = async () => {
    let custUrl =
      storeApiUrl.BACKEND_BASE_URL +
      getPreUrlAccordingToCart(storeCartType) +
      GET_CUSTOMER_DATA;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
      },
    };
    setLoading(true);
    snpAxios
      .post(custUrl, data)
      .then((response) => {
        setLoading(false);
        if (response.data.status === SUCCESS) {
          setCustomers(response.data.jcJson.value_2);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error : ", error);
        //window.location.href = "#/error";
      });
  };
  // Load initial data
  useEffect(() => {
    fetchCustomerData();
  }, []);


  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 8,
          flexDirection: "column",
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography color="text.secondary">
          Initializing Marketing Hub...
        </Typography>
      </Box>
    );
  }


  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 4 }}
    >
      {/* Page Heading & Status */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "primary.main",
              letterSpacing: "-0.02em",
            }}
          >
            Customer Directory
          </Typography>
        </Box>
      </Box>

      <Paper
        variant="outlined"
        sx={{
          height: 650,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 3,
          width: "100%",
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "rgba(0, 0, 0, 0.02)",
          }}
        >
          <Typography
            variant="overline"
            sx={{ fontWeight: 700, fontFamily: 'Vazir', fontSize: '1.25rem', color: "black" }}
          >
            RECIPIENT LIST
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontWeight: 800,  fontFamily: 'Vazir', fontSize: '1.25rem', color: "primary.main" }}
          >
            {selectedCustomerIds.length} SELECTED
          </Typography>
        </Box>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <CustomerSelector
            customers={customers}
            selectedIds={selectedCustomerIds}
            onSelectionChange={setSelectedCustomerIds}
          />
        </Box>
      </Paper>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setError(null)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default MarketingPage;
